export default __webpack_public_path__ + "static/media/subscribe-day.ee69e114.png";